import { useQuery } from "@tanstack/react-query";
import { getLora } from "../../services/lorasApi";
import { loraQueryKeys } from "./queryKeys";

export function useLora(loraId: string | undefined | null) {
  return useQuery({
    queryKey: loraId
      ? loraQueryKeys.detail(loraId)
      : (["loras", "detail", "_disabled"] as const),
    queryFn: () => getLora(loraId as string),
    enabled: Boolean(loraId),
  });
}
